module.exports = __webpack_public_path__ + "img/barilla-tw-pic.png?f4f9af74b7a3cc8576d643be42c85e40";